<template>
  <el-dialog title="增加奖品数量" :visible="isShowAddNum" width="500px" @close="close">
      <div>
        <jd-tip style="margin-bottom: 20px">活动进行中时，只能增加奖品数量</jd-tip>
        <el-form label-width="170px" v-if="prizeData">
          <el-form-item label="奖品名称：">
            <span>{{ prizeData.title }}</span>
          </el-form-item>
          <el-form-item label="当前活动奖品总数量：">
            <span>{{ prizeData.num }}</span>件
          </el-form-item>
          <el-form-item label="增加数量：">
            <el-input v-model="addNum" style="width: 150px;"
              @input="addNum = getNumberData(1,$event,0,1,999999)">
            </el-input>
          </el-form-item>
          <el-form-item label="追加后奖品总数量数量：">
            <span>{{ afterTotal }}</span>件
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="close">取消</jd-button>
        <jd-button @click="confirmChange()" type="blue" style="margin-left: 8px">确定</jd-button>
      </div>
    </el-dialog>
</template>
<script>
import { checkPrizeStock,pointsExchangeAddStock } from "@/api/jhk/integralCenter/integralTask.js";
export default {
  props:{
    isShowAddNum: {
      type: Boolean,
      default: false
    },
    prizeData: {
      type: Object,
      default: {}
    },
    isExchangeAct: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addNum: '',
    }
  },
  computed:{
    afterTotal() {
      if(this.prizeData){
        console.log("this.prizeData",this.prizeData)
        return Number(this.prizeData.num) + Number(this.addNum)
      }else {
        return 0;
      }
    }
  },
  methods: {
    close() {
      this.$emit('close');
      this.addNum = '';
    },
    confirmChange() {
      if(this.isExchangeAct) {
        // TODO: 增加兑换活动奖品数量逻辑
        pointsExchangeAddStock({
          activityId: this.prizeData.activityId,
          addStock: this.addNum
        }).then((res)=>{
          if(res.code == 1){
            this.$emit('confirm', this.afterTotal);
            this.addNum = '';
            this.$message.success("新增库存成功")
          }else {
            this.$message.error("新增失败！")
          }
        })
      } else {
        checkPrizeStock({
          couponType: this.prizeData.prizeType == 1? this.prizeData.couponType : undefined,
          prizeType: this.prizeData.prizeType,
          assetsId: this.prizeData.assetsId || this.prizeData.id,
          needNum: this.afterTotal
        }).then((res)=>{
          if(res.code == 1){
            if(res.data) {
              this.$emit('confirm', this.afterTotal);
              this.addNum = '';
            } else {
              this.$message.error(`${this.prizeData.title}修改的奖品数量不能大于奖项剩余值！`)
            }
          }else {
            this.$message.error("新增数量不能大于该奖品的剩余数量！")
          }
        })
      }
    }
  },
}
</script>

<style>

</style>